import SockJS from "sockjs-client";
import { Client, IMessage } from "@stomp/stompjs";
import { BASE_URL } from "../configs/apiConfig";

export type AuthEventCallback = (event: string) => void;

export const connectAuthSocket = (userId: number, callback: AuthEventCallback) => {
  const socket = new SockJS(`${BASE_URL}/ws`);
  const client = new Client({
    webSocketFactory: () => socket as any,
    reconnectDelay: 5000,
    onConnect: () => {
      client.subscribe(`/topic/auth/${userId}`, (message: IMessage) => {
        try {
          const payload = JSON.parse(message.body);
          callback(payload.event);
        } catch (error) {
          console.error("Failed to parse auth event message", error);
        }
      });
    },
    onStompError: (frame) => {
      console.error("STOMP error:", frame.headers["message"]);
    },
    onWebSocketError: (error) => {
      console.error("WebSocket error:", error);
    },
  });

  client.activate();
  return client;
};
